import { useEffect, useRef } from 'react';

function useRunOnce( fn: () => void, sessionKey?: string) {
  const triggered = useRef<boolean>(false);

  useEffect(() => {
    const hasBeenTriggered = sessionKey
      ? sessionStorage.getItem(sessionKey)
      : triggered.current;

    if (!hasBeenTriggered) {
      fn();
      triggered.current = true;

      if (sessionKey) {
        sessionStorage.setItem(sessionKey, 'true');
      }
    }
  }, [fn, sessionKey]);

  return null;
};

export default useRunOnce;
